// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-chat-v{
  display: flex;
  flex-direction: row;
  max-width: 100%;
}

.left-section-chat-v{
  display: flex;
  flex-direction: column;
  background-color: rgba(30, 32, 61, 1);
  position: absolute;
  width: 80%;
  /* height: 410px; */
  /* left: 80px; */
  max-width: 100%;
  height:65%;
  top: 150px;
  border-radius: 10px;
  margin-left: 20px;
  margin-top: 5px;
  border: 1px solid rgba(107, 92, 209, 1);
}

/* .right-section-chat-v{
  display: flex;
  flex-direction: column;
  background-color: rgba(30, 32, 61, 1);
  position: absolute;
  width: 600px;
  height: 450px;
  left: 600px;
  top: 150px;
  border-radius: 10px;
  margin-left: 20px;
  margin-top: 5px;
} */

.top-part-chart-v{
  height: 40px;
border-top-left-radius: 10px;
border-top-right-radius: 10px;
display: flex;
flex-direction: row;
background-color: rgb(54, 54, 89);
padding: 5px;
color: white;
font-size: 13px;
font-weight: 500;
}

.title-chart-v{
  margin-top: 5px;
margin-left: 10px;
font-size: 13px;
font-family: Graphik;
font-weight: 400;
}

.middle-part-chart-v{
 
/* max-height: 430px; */
     
height: 930px;
  color: white;
  font-size: 10px;
}

.chat-message-v{
max-height: 270px;
min-height: 270px;
 /* max-height: 70%; */
/* min-height: 100%; */ 
/* height: 0%; */
overflow-y: scroll;
/* display: flex; */
flex-direction: column;
margin-bottom: 10px;
}

.user-c-v{
  /* align-items: end; */
/* min-width: 50px;
margin-top: 10px;
margin-bottom: 10px; */
margin-right:30px;
/* margin-left: 100px; */
text-align: right;
position: relative;
/* max-width: 500px; */
/* padding: 10px; */
width: fit-content;
float: right;
padding: 5px;
justify-content: flex-end;

}

.bot-c-v{
min-width: 50px;
margin-top: 10px;
position: relative;
max-width: 640px;
margin-bottom: 10px;
/* min-height: 60px; */
/* max-height: 100%; */
/* height: fit-content; */
/* display: block; */
/* overflow: auto; */
padding: 10px;
color: white;
text-align: left;
/* margin-right: 30px; */
width: fit-content;
float: left;
}

.user-c-v .message-text-chart-v {
  
  background-color: #4D5699;
}

.bot-c-v .message-text-chart-v{
  background-color:  rgba(45, 50, 90, 1);
}

.icon-chat-user-v{
width: 25px;
position:absolute;
margin-left: 560px;



}

.icon-chat-bot-v{
  width: 25px;
  position: absolute;
}

.chat-message{
  display: flex;
border-radius: 5px;
flex-direction: row; 
}

.chat-message.user-c-v{
  text-align: left;
  /* background-color: #4D5699; */
}


.message-text-chart-v{
background-color: rgba(45, 50, 90, 1); 
padding: 10px;
 margin-left: 50px; 
margin-right: 10px; 
 color: white;
border-radius: 10px;
min-width: 500px; 
/* width: fit-content;  */
 max-width: 500px;
 font-size: 12px;

/* padding: 10px 10px 10px 10px;
/* font-size: 12px; */
/* color: white;
border-radius: 5px; */
/* max-width: 1000px;
width: fit-content; */
/* margin-left: 30px; */ 
}


.chat-input-container-chart-v{
display: flex;
/* margin-top: 8%; */
}   

.text-chart-v{
      border: 1px solid #3f596d;
      height: 40px;
      background-color: #3f596d;
      border-radius:20px;
      width: 91%;
      margin-right: 5px;
      overflow-y: hidden;
      margin-left: 18px;
      padding-right: 100px;
      padding-left: 20px;
      position: absolute;
      color: white;
}

.mic-chart-v{
  width: 3%;
  float: right;
  position: relative;
  right: -45px;
  top: 4px;
}

.send-chart-v{
      padding:10px;
      width: 70%;
}

.chat-input-chart-v{
  
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 2px;
  width: 88%;
  font-family: 'Graphik', sans-serif;
  color: black;
  font-size: 14px;
  height: 40px; 
}

.send-back-chart-v{
  background-color: #3f596d;
      border-radius: 20px;
      /* width: 8%; */
      /* margin-bottom: 10px; */
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      margin-left: 50px;
      z-index:1000;
}

.user-message-container {
  display: flex;
  justify-content: flex-start; /* Align to the left for user messages */
  margin: 5px 0;
}

.bot-message-container {
  display: flex;
  justify-content: flex-end; /* Align to the right for bot messages */
  margin: 5px 0;
}  

.bot-table-response-d{
  max-width: 100%;
  overflow-x: auto;
}

.bottom-part-chart-v{
 
/* border-top: 1px solid  rgba(14, 190, 147, 1);
margin-right: 80px; */
margin-top: auto;
z-index: 1000;

}
/* .user-message-v{
  color:white;
  background-color: #4D5699;
} */
.bot-text-response-d{
  /* background-color: #747BA9; */
  color: white;
}


.mytable-d {
  border-collapse: collapse;
  width: 100%;
}

.mytable-d th, .mytable-d td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

 .mytable-d th {
  background-color: #747BA9;
  color: #3BBC6F;
}

.mytable-d tr{
  background-color:#27284B;
}

/* .mytable-d tr:hover {
  background-color: #f5f5f5;
} */ 

/* Additional styles for better alignment */
.mytable-d th, .mytable-d td {
  text-align: center; /* Adjust text alignment as needed */
}

/* .mytable-d th:first-child, .mytable-d td:first-child {
  text-align: left; 
} */
`, "",{"version":3,"sources":["webpack://./src/ChatbotV.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;AACzC;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,YAAY;AACd,4BAA4B;AAC5B,6BAA6B;AAC7B,aAAa;AACb,mBAAmB;AACnB,iCAAiC;AACjC,YAAY;AACZ,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB;;AAEA;EACE,eAAe;AACjB,iBAAiB;AACjB,eAAe;AACf,oBAAoB;AACpB,gBAAgB;AAChB;;AAEA;;AAEA,uBAAuB;;AAEvB,aAAa;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;AACA,iBAAiB;AACjB,iBAAiB;CAChB,qBAAqB;AACtB,sBAAsB;AACtB,gBAAgB;AAChB,kBAAkB;AAClB,mBAAmB;AACnB,sBAAsB;AACtB,mBAAmB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;sBAEsB;AACtB,iBAAiB;AACjB,wBAAwB;AACxB,iBAAiB;AACjB,kBAAkB;AAClB,sBAAsB;AACtB,mBAAmB;AACnB,kBAAkB;AAClB,YAAY;AACZ,YAAY;AACZ,yBAAyB;;AAEzB;;AAEA;AACA,eAAe;AACf,gBAAgB;AAChB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,sBAAsB;AACtB,sBAAsB;AACtB,yBAAyB;AACzB,oBAAoB;AACpB,oBAAoB;AACpB,aAAa;AACb,YAAY;AACZ,gBAAgB;AAChB,wBAAwB;AACxB,kBAAkB;AAClB,WAAW;AACX;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;AACA,WAAW;AACX,iBAAiB;AACjB,kBAAkB;;;;AAIlB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf,kBAAkB;AAClB,mBAAmB;AACnB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;;AAGA;AACA,qCAAqC;AACrC,aAAa;CACZ,iBAAiB;AAClB,kBAAkB;CACjB,YAAY;AACb,mBAAmB;AACnB,gBAAgB;AAChB,yBAAyB;CACxB,gBAAgB;CAChB,eAAe;;AAEhB;qBACqB;AACrB;qBACqB;AACrB;qBACqB;AACrB,uBAAuB;AACvB;;;AAGA;AACA,aAAa;AACb,oBAAoB;AACpB;;AAEA;MACM,yBAAyB;MACzB,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,UAAU;MACV,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,oBAAoB;MACpB,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;MACM,YAAY;MACZ,UAAU;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;MACrB,mBAAmB;MACnB,eAAe;MACf,yBAAyB;MACzB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,YAAY;MACZ,iBAAiB;MACjB,YAAY;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B,EAAE,wCAAwC;EACrE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,wCAAwC;EACnE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;AAEA;qBACqB;AACrB,gBAAgB;AAChB,aAAa;;AAEb;AACA;;;GAGG;AACH;EACE,+BAA+B;EAC/B,YAAY;AACd;;;AAGA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;CAEC;EACC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH,2CAA2C;AAC3C;EACE,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;;GAEG","sourcesContent":[".main-chat-v{\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n}\n\n.left-section-chat-v{\n  display: flex;\n  flex-direction: column;\n  background-color: rgba(30, 32, 61, 1);\n  position: absolute;\n  width: 80%;\n  /* height: 410px; */\n  /* left: 80px; */\n  max-width: 100%;\n  height:65%;\n  top: 150px;\n  border-radius: 10px;\n  margin-left: 20px;\n  margin-top: 5px;\n  border: 1px solid rgba(107, 92, 209, 1);\n}\n\n/* .right-section-chat-v{\n  display: flex;\n  flex-direction: column;\n  background-color: rgba(30, 32, 61, 1);\n  position: absolute;\n  width: 600px;\n  height: 450px;\n  left: 600px;\n  top: 150px;\n  border-radius: 10px;\n  margin-left: 20px;\n  margin-top: 5px;\n} */\n\n.top-part-chart-v{\n  height: 40px;\nborder-top-left-radius: 10px;\nborder-top-right-radius: 10px;\ndisplay: flex;\nflex-direction: row;\nbackground-color: rgb(54, 54, 89);\npadding: 5px;\ncolor: white;\nfont-size: 13px;\nfont-weight: 500;\n}\n\n.title-chart-v{\n  margin-top: 5px;\nmargin-left: 10px;\nfont-size: 13px;\nfont-family: Graphik;\nfont-weight: 400;\n}\n\n.middle-part-chart-v{\n \n/* max-height: 430px; */\n     \nheight: 930px;\n  color: white;\n  font-size: 10px;\n}\n\n.chat-message-v{\nmax-height: 270px;\nmin-height: 270px;\n /* max-height: 70%; */\n/* min-height: 100%; */ \n/* height: 0%; */\noverflow-y: scroll;\n/* display: flex; */\nflex-direction: column;\nmargin-bottom: 10px;\n}\n\n.user-c-v{\n  /* align-items: end; */\n/* min-width: 50px;\nmargin-top: 10px;\nmargin-bottom: 10px; */\nmargin-right:30px;\n/* margin-left: 100px; */\ntext-align: right;\nposition: relative;\n/* max-width: 500px; */\n/* padding: 10px; */\nwidth: fit-content;\nfloat: right;\npadding: 5px;\njustify-content: flex-end;\n\n}\n\n.bot-c-v{\nmin-width: 50px;\nmargin-top: 10px;\nposition: relative;\nmax-width: 640px;\nmargin-bottom: 10px;\n/* min-height: 60px; */\n/* max-height: 100%; */\n/* height: fit-content; */\n/* display: block; */\n/* overflow: auto; */\npadding: 10px;\ncolor: white;\ntext-align: left;\n/* margin-right: 30px; */\nwidth: fit-content;\nfloat: left;\n}\n\n.user-c-v .message-text-chart-v {\n  \n  background-color: #4D5699;\n}\n\n.bot-c-v .message-text-chart-v{\n  background-color:  rgba(45, 50, 90, 1);\n}\n\n.icon-chat-user-v{\nwidth: 25px;\nposition:absolute;\nmargin-left: 560px;\n\n\n\n}\n\n.icon-chat-bot-v{\n  width: 25px;\n  position: absolute;\n}\n\n.chat-message{\n  display: flex;\nborder-radius: 5px;\nflex-direction: row; \n}\n\n.chat-message.user-c-v{\n  text-align: left;\n  /* background-color: #4D5699; */\n}\n\n\n.message-text-chart-v{\nbackground-color: rgba(45, 50, 90, 1); \npadding: 10px;\n margin-left: 50px; \nmargin-right: 10px; \n color: white;\nborder-radius: 10px;\nmin-width: 500px; \n/* width: fit-content;  */\n max-width: 500px;\n font-size: 12px;\n\n/* padding: 10px 10px 10px 10px;\n/* font-size: 12px; */\n/* color: white;\nborder-radius: 5px; */\n/* max-width: 1000px;\nwidth: fit-content; */\n/* margin-left: 30px; */ \n}\n\n\n.chat-input-container-chart-v{\ndisplay: flex;\n/* margin-top: 8%; */\n}   \n\n.text-chart-v{\n      border: 1px solid #3f596d;\n      height: 40px;\n      background-color: #3f596d;\n      border-radius:20px;\n      width: 91%;\n      margin-right: 5px;\n      overflow-y: hidden;\n      margin-left: 18px;\n      padding-right: 100px;\n      padding-left: 20px;\n      position: absolute;\n      color: white;\n}\n\n.mic-chart-v{\n  width: 3%;\n  float: right;\n  position: relative;\n  right: -45px;\n  top: 4px;\n}\n\n.send-chart-v{\n      padding:10px;\n      width: 70%;\n}\n\n.chat-input-chart-v{\n  \n  margin-right: 10px;\n  margin-bottom: 10px;\n  padding: 2px;\n  width: 88%;\n  font-family: 'Graphik', sans-serif;\n  color: black;\n  font-size: 14px;\n  height: 40px; \n}\n\n.send-back-chart-v{\n  background-color: #3f596d;\n      border-radius: 20px;\n      /* width: 8%; */\n      /* margin-bottom: 10px; */\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 40px;\n      margin-left: 50px;\n      z-index:1000;\n}\n\n.user-message-container {\n  display: flex;\n  justify-content: flex-start; /* Align to the left for user messages */\n  margin: 5px 0;\n}\n\n.bot-message-container {\n  display: flex;\n  justify-content: flex-end; /* Align to the right for bot messages */\n  margin: 5px 0;\n}  \n\n.bot-table-response-d{\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.bottom-part-chart-v{\n \n/* border-top: 1px solid  rgba(14, 190, 147, 1);\nmargin-right: 80px; */\nmargin-top: auto;\nz-index: 1000;\n\n}\n/* .user-message-v{\n  color:white;\n  background-color: #4D5699;\n} */\n.bot-text-response-d{\n  /* background-color: #747BA9; */\n  color: white;\n}\n\n\n.mytable-d {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.mytable-d th, .mytable-d td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n .mytable-d th {\n  background-color: #747BA9;\n  color: #3BBC6F;\n}\n\n.mytable-d tr{\n  background-color:#27284B;\n}\n\n/* .mytable-d tr:hover {\n  background-color: #f5f5f5;\n} */ \n\n/* Additional styles for better alignment */\n.mytable-d th, .mytable-d td {\n  text-align: center; /* Adjust text alignment as needed */\n}\n\n/* .mytable-d th:first-child, .mytable-d td:first-child {\n  text-align: left; \n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
